// extracted by css-extract-rspack-plugin
export default {"container":"GenerationSelectors-module__container--XBZ4i","row":"GenerationSelectors-module__row--KUm0c","selector":"GenerationSelectors-module__selector--oVwaJ"};